import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { inject, observer } from 'mobx-react';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Fade from 'react-reveal/Fade';
import ReactGA from 'react-ga';
import './AuthLogin.css';
import { Link } from 'react-router-dom';
import { setDigitalData } from '../../Utilities/Utils.js';

const theme = createMuiTheme({
    palette: {
        primary: {
            light: "#3CB6CE",
            main: "#3CB6CE",
            dark: "#3CB6CE",
            contrastText: "#3CB6CE"
        },
        text: {
            primary:"white" ,
            secondary: "white"
        },
        action: {
            active:"white"
        }
    },
    typography : {
        fontFamily: ['Roboto Condensed','Roboto','Helvetica'].join(','),
        fontSize: "20",
    }
});

const styles = {
    resize:{
    },
    labelResize:{
    },
    menuItem:{
        color:'black',
    },
    underline: {
        color: theme.palette.common.white,
        borderBottom: theme.palette.common.white,
        '&:after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:focused::after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:before': {
            borderBottom: `1px solid ${theme.palette.common.white}`,
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
            borderBottom: '2px solid rgb(255, 255, 255) !important',
        },
        '&$disabled:before': {
            borderBottom: `1px dotted ${theme.palette.common.white}`,
        },
    },
    disabled: {},
    focused: {},
    error: {}
}

class DGRAuthLogin extends Component {

    componentDidMount() {
        this.props.DGRBackgroundStore.showBlurAndHeader()
        this.props.DGRStore.errors = null;
        setDigitalData( 'auth login', this.props.DGRStore.club_number );
    }

    handleTextChange = (e) => {
        this.props.DGRStore.setValue( e.target.name, e.target.value );
    }
    handleCheckboxChange = (e) => {
        this.props.DGRStore.setValue( e.target.name, e.target.checked );
    }

    handleSubmitUserPass = (e) => {

        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Member Login',
            action: 'Login Form'
        });

        this.props.DGRStore.authLogin().then( path => {
            if ( path && path.indexOf('http:') > -1 ) {
                window.location.href = path;
            } else if ( path ) {
                this.props.history.push( path );
            }
        });
    }

    errorText() {

        if ( !this.props.DGRStore.errors ) {
            return null;
        }
 
        return (
            <div className="errorMessage">
                { this.props.DGRStore.errors }
            </div>
        );
    }

    render(){
        const { classes } = this.props;

        const { username, password } = this.props.DGRStore.values;

        return(
            <Fade>
            <div className="authLogin">
                <MuiThemeProvider theme={theme}>

                <div className="dgrTitleText">
                    <h2>Welcome!</h2>
                </div>

                <div className="dgrTitleSubText">
                    <div className="subText">
                        Please sign in to add services, upgrade membership, manage EasyPay, and purchase personal training.
                    </div>
                </div>

                <div className="loginItems">  
                    <ValidatorForm
                        className="loginForm"
                        ref="form"
                        autoComplete="off"
                        instantValidate={ false }
                        onSubmit={ this.handleSubmitUserPass }
                        onError={ errors => console.log('Errors: ' + errors) }
                    >
                        <div className="row">
                            <TextValidator
                                autoComplete="off"
                                label="Username"
                                name="username"
                                id="usernameField"
                                value={ username }
                                key="0"
                                onChange={ this.handleTextChange }
                                placeholder="My24 Username"
                                className="inputField"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                        underline: classes.underline
                                    },
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.labelResize,
                                    },
                                }}
                                validators={['required']}
                                errorMessages={['This field is required']}
                                margin="normal"
                            />
                        </div>
                        <div className="row">
                            <TextValidator
                                autoComplete="off"
                                label="Password"
                                name="password"
                                id="passwordField"
                                value={ password }
                                onChange={ this.handleTextChange }
                                type="password"
                                placeholder="My24 Password"
                                className="inputField"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                        underline: classes.underline
                                    },
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.labelResize,
                                    },
                                }}
                                validators={['required']}
                                errorMessages={['This field is required']}
                                margin="normal"
                            />
                        </div>

                        { this.errorText() }

                        <div className="continueBtn">
                            <button className="bigButton" type="submit">Login</button>
                        </div>

                        <div className="subLink">
                            <Link to="/auth/forgot"> 
                                I forgot my username/password.
                            </Link>
                        </div>

                    </ValidatorForm>

                    <Link className="createNewButton" to="/auth/validate"> 
                        Create New Account
                    </Link>

                </div>
                </MuiThemeProvider>
            </div>
            </Fade>
        )
    }
}

DGRAuthLogin = inject('DGRBackgroundStore','DGRStore')( observer( DGRAuthLogin ) )

export default withStyles( styles )( DGRAuthLogin );



// WEBPACK FOOTER //
// ./src/components/DGR/AuthLogin/AuthLogin.js